<template>
  <div>
    <v-container container--fluid>
      <v-row class="px-4">
          <h1>Manage Users</h1>
          <v-spacer></v-spacer>
          <v-tooltip top color="secondary" v-if="userEdit">
            <template v-slot:activator="{ on }">
              <v-btn fab dark v-if="userEdit" color="blue lighten-1" @click="newUser" v-on="on">
                <v-icon dark>add</v-icon>
              </v-btn>
            </template>
            <span>Create a new user</span>
          </v-tooltip>
      </v-row>

       <v-row justify="space-between">
        <v-col cols="12" md="4">
          <v-text-field
            label="Search..."
            v-model="search"
            prepend-inner-icon="search"
          ></v-text-field>
        </v-col>
       </v-row>
    </v-container>
    <v-data-table
      :key="keyDataTable"
      :search="search"
      :headers="headers"
      :items="items"
    >
      <v-toolbar text>
      </v-toolbar>
      <template v-slot:item="props">
        <tr class="cursor" v-bind:class="{odd: props.index % 2, even: !props.index % 2}" @click="rowSelect(props.item)">
          <td style="text-align: center" v-for="(header, index) in headers" :key="index">
            {{props.item[header.value]}}
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog width="500px" v-model="newUserDialog">
      <v-form v-model="valid" ref="formUser">
        <v-card>
          <v-card-title class="d-flex" style="position: relative" :class="$vuetify.breakpoint.smAndDown ? 'justify-start' : 'justify-center'">
            <h2>{{editedIndex === -1 ? 'New User' : 'Edit User'}}</h2>
            <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="newUserDialog=false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider color="#42a5f5"></v-divider>
          <v-container container--fluid grid-list-xl px-6>
             <v-row justify="center">
              <v-col cols="12" sm="12" md="6" v-for="header in flds" :key="header.model">

                <v-text-field
                  v-if="header.model !== 'email' && header.model !== 'password' && header.model !== 'username'
                  && header.field === 'text'"
                  v-model="editedItem[header.model]"
                  :label="header.label"
                  :name="editedItem[header.model]"
                  :readonly="!userEdit"
                ></v-text-field>

                <v-text-field
                  v-if="header.model === 'username'"
                  :label="header.label"
                  :rules="usernameRule"
                  :readonly="editedIndex > -1 || !userEdit"
                  v-model="editedItem[header.model]"
                  :name="editedItem[header.model]"
                ></v-text-field>

                <v-autocomplete
                  v-if="header.model === 'client_id'"
                  :label="header.label"
                  :items="clients"
                  item-value="id"
                  item-text="name"
                  :rules="[v => v !== null || 'Choose a valid client']"
                  v-model="editedItem[header.model]"
                  :readonly="!userEdit"
                ></v-autocomplete>

                <v-text-field
                  v-if="header.model === 'password'"
                  :label="header.label"
                  :rules="passwordRule"
                  v-model="editedItem[header.model]"
                  :name="editedItem[header.model]"
                  :readonly="!userEdit"
                ></v-text-field>

                <v-text-field
                  v-if="header.model === 'email'"
                  :label="header.label"
                  :rules="emailRule"
                  v-model="editedItem[header.model]"
                  :name="editedItem[header.model]"
                  :readonly="!userEdit"
                ></v-text-field>

                <v-switch
                  class="justify-center"
                  v-if="header.model === 'force_change'"
                  :label="header.label"
                  v-model="editedItem[header.model]"
                  :items="header.selectItems"
                  :readonly="!userEdit"
                ></v-switch>

                <v-switch
                  class="justify-center"
                  v-if="header.model === 'active'"
                  :label="header.label"
                  v-model="editedItem[header.model]"
                  :items="header.selectItems"
                  :readonly="!userEdit"
                ></v-switch>

              </v-col>
             </v-row>
            <v-card-actions class="justify-center" :class="{'flex-between': $vuetify.breakpoint.smAndDown}">
              <v-btn text color="blue-grey lighten-2" @click="close()">Cancel</v-btn>
              <v-btn text color="indigo" @click="togglePermissionDialog" v-if="permissionUserPermissionView && editedIndex != -1">Permissions</v-btn>
              <v-btn text color="green" @click="togglePermissionGroupDialog" v-if="permissionUserPermissionView && editedIndex != -1">Group Permissions</v-btn>
              <v-btn text color="blue darken-1" @click="save" v-if="userEdit" class="white--text" :disabled="!valid">Save</v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="permissionDialog" width="1000px">
      <ManagePermissions
        :user="editedItem"
        :regions="regions"
        :user-permission="Object.values(permissions)"
        :all-permissions="allPermissions"
        v-if="permissions && regions"
      ></ManagePermissions>
    </v-dialog>

    <v-dialog v-model="permissionGroupDialog" width="1200px">
      <v-card>
        <v-card-title class="text-center" style="white-space: nowrap">
          <h2>Add User In Permission Group</h2>
          <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="permissionGroupDialog=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
          <v-row :justify="$vuetify.breakpoint.smAndDown ? 'center' : 'space-between'">
            <v-col cols="12" sm="5" md="3">
              <v-text-field label="Search..." v-model="searchPermission" prepend-icon="search"></v-text-field>
            </v-col>
            <v-col cols="4" sm="4" md="2">
              <div style="display: flex; justify-content: center; align-items: center">
                <v-btn text @click="refresh" v-if="!isVisible">
                  <v-icon color="cyan darken-2">refresh</v-icon>
                </v-btn>
                <v-btn text @click="showUserAuditLog">
                  <v-icon color="amber darken-2">history</v-icon>
                </v-btn>
                <div v-if="isVisible" class="load-3">
                  <div class="line"></div>
                  <div class="line"></div>
                  <div class="line"></div>
                </div>
              </div>
            </v-col>
            <v-col cols="4" sm="4" md="2" class="text-center" v-if="$vuetify.breakpoint.mdAndUp">
            </v-col>
            <v-col cols="4" sm="4" md="2" class="text-center" v-if="$vuetify.breakpoint.mdAndUp">
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-btn class="mx-2" fab dark color="blue lighten-1" @click="addExsitGroup" v-on="on">
                    <v-icon dark>add</v-icon>
                  </v-btn>
                </template>
                <span>Add user in group Permission</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-data-table
            :search="searchPermission"
            :headers="headersPermission"
            :items="rendereUserPermissionsGroup"
            item-key="name"
            class="elevation-1"
          >
            <template v-slot:item="props">
              <tr v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
                <td v-if="header.text !== 'Actions'" style="text-align: center" v-for="(header, index) in headersPermission" :key="index">
                  {{props.item[header.value]}}
                </td>
                <td v-else style="text-align: center">
                  <v-tooltip top color="secondary">
                    <template v-slot:activator="{ on }">
                      <v-icon color="blue" @click="editUserGroup(props.item)" v-on="on" class="pl-1">
                        edit
                      </v-icon>
                    </template>
                    <span>Remove or add region on user</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addUserInGroupDialog" width="1000px">
      <v-card>
        <v-card-title>
          <h2>Add User On Region In Permission Group {{selectGroupName}}</h2>
          <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="addUserInGroupDialog=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider color="#42a5f5"></v-divider>
        <v-card-text>
          <v-container>
            <v-row dense  v-show="editUserOnGroup">
              <v-autocomplete
                label="Choose a group..."
                :items="rendereAllPermissionsGroup"
                item-text="name"
                return-object
                v-model="selectGroup"
                prepend-icon="fas fa-user"
              ></v-autocomplete>
            </v-row>
            <v-row justify="center">
              <v-col cols="12">
                <v-card  v-show="selectGroup">
                  <v-list  scrollable style="height: 400px; overflow: scroll">
                    <v-list-item
                      v-for="(region, index) in renderedRegions"
                      :key="index"
                    >
                      <v-list-item-action>
                        <v-checkbox @change="addUserGroup(region)" v-model="region.in_group"
                        ></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-title>{{region.name}}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="blue-grey lighten-2" @click="addUserInGroupDialog=false">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="userAuditLogDialog" width="1200px">
      <v-card>
        <v-card-title>
          <h2>{{'Audit Log - User ' + editedItem.username}}</h2>
          <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="closeUserAuditLog">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider color="#42a5f5"></v-divider>
        <v-card-text>
          <v-data-table
            :headers="headersUserAuditLog"
            :items="userAuditLogData"
            :loading="userAuditLogLoading"
          >
            <template v-slot:item="props">
              <tr v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
                <td style="text-align: center" v-for="(header, index) in headersUserAuditLog" :key="index">
                  {{props.item[header.value]}}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
  import axios from 'axios'
  import ManagePermissions from "./ManagePermissions";


  // @vuese
  // Table of all the users the user can modify the information
  // @group Manage Users
  export default {
    name: "ManageUsersTable",
    components: {
      ManagePermissions
    },
    props: {
      items: Array,
    },
    data() {
      return {
        search: null,
        roleRule: [
          (v) => {
            if (this.editedIndex === -1) {
              return !!v || 'This field is required'
            } else {
              return true
            }
          }
        ],
        requiredRule: [
          v => !!v || 'This field is required'
        ],
        usernameRule: [
          v => !!v || 'This field is required',
          v => /([A-Za-z0-9])\w+/.test(v) || 'Username must be valid'
          // v => /^[A-Za-z0-9]+(?:[ _-][A-Za-z0-9]+)*$/.test(v) || 'Username must be valid'
        ],
        emailRule: [
          v => !!v || 'This field is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
        ],
        passwordRule: [
          (v) => {
            if (this.editedIndex > -1) {
              return true
            }
            return !!v || 'This field is required'
          },
          (v) => {
            if (this.editedIndex > -1) {
              return true
            }
            if (v !== null && v !== undefined) {
              return v.length > 6 || 'Password must be valid'
            }
            return 'This field is required'
          }
        ],
        headers: [
          {text: 'ID', value: 'id', align: 'center'},
          {text: 'Client', value: 'client_name', align: 'center'},
          {text: 'Name', value: 'full_name', align: 'center'},
          {text: 'Email', value: 'email', align: 'center'},
          {text: 'Username', value: 'username', align: 'center'},
        ],
        headersPermission:[
          {text: 'Group Name', value: 'name', align: 'center', sortable: true},
          {text: 'Description', value: 'description', align: 'center', sortable: true},
          {text: 'Type', value: 'type_text', align: 'center', sortable: true},
          {text: 'Actions', value: 'actions', align: 'center', sortable: false}
        ],
        flds: [
          {
            label: 'ID',
            model: 'id',
            field: 'text',
          },
          {
            label: 'Username',
            model: 'username',
            field: 'text',
          },
          {
            label: 'Client',
            model: 'client_id',
            field: 'select',
          },
          {
            label: 'Email',
            model: 'email',
            field: 'text',
          },
          {
            label: 'Password',
            model: 'password',
            field: 'text',
          },
          {
            label: 'Force Change',
            model: 'force_change',
            field: 'switch',
          },
          {
            label: 'First Name',
            model: 'first_name',
            field: 'text',
          },
          {
            label: 'Last Name',
            model: 'last_name',
            field: 'text',
          },
          {
            label: 'Active',
            model: 'active',
            field: 'switch',
          },
        ],
        valid: false,
        newUserDialog: false,
        editedItem:
          {
            id: 0,
            username: null,
            email: null,
            password: null,
            force_change: null,
            client_id: null,
            first_name: null,
            last_name: null,
            active: null,
          },
        defaultItem:
          {
            id: 0,
            username: null,
            email: null,
            password: null,
            force_change: null,
            client_id: null,
            first_name: null,
            last_name: null,
            active: null,
          },
        editedIndex: -1,
        permissionDialog: false,
        permissions: null,
        allPermissions: null,
        keyDataTable: 0,
        permissionGroupDialog:false,

        searchPermission:'',
        loading: false,
        reload: false,
        addUserInGroupDialog:false,
        selectGroup:null,
        isVisible: false,
        editUserOnGroup: -1,
        selectGroupName:null,
        userAuditLogDialog:false,
        userAuditLogData:[],
        userAuditLogLoading:false,
        headersUserAuditLog:[
          {text: 'Permission Group', value: 'permission_group_name', align: 'center', sortable: true},
          {text: 'Action', value: 'action', align: 'center', sortable: true},
          {text: 'Region', value: 'region_name', align: 'center', sortable: true},
          {text: 'Performed By', value: 'performed_by_name', align: 'center', sortable: true},
          {text: 'Date', value: 'created_at', align: 'center', sortable: true},
        ]
      }
    },
    methods: {
      newUser(){
        this.editedIndex =  -1,
        this.newUserDialog=true;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.valid = false
      },
      // @vuese
      // Gets the permissions either for a specific user or for all users
      togglePermissionDialog() {
        if (!this.permissionDialog) {
          axios.get(process.env.API_URL + '/users/' + this.editedItem.id + '/permissions')
            .then((response) => {
              this.permissions = response.data;
              // this.permissionDialog = !this.permissionDialog;
            });
          axios.get(process.env.API_URL + '/users/permissions')
            .then((response) => {
              this.allPermissions = response.data;
            });
          this.permissionDialog = !this.permissionDialog;
        }

      },
      togglePermissionGroupDialog(){
        this.permissionGroupDialog = true;
      },
      // @vuese
      // Resets all the relevant variables to default (editedIndex, editedItem) and closes the newUserDialog
      close() {
        this.editedIndex = -1;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.newUserDialog = false;
        this.valid = false
        // this.valid = false;
      },
      // @vuese
      // Stores the user object user just clicked on into editedItem variable, stores the index of this object,
      // and opens newUserDialog
      // @arg Takes a user object as an argument.
      rowSelect(item) {
        this.valid = true;
        this.editedItem = Object.assign({}, item);
        this.editedIndex = this.items.indexOf(item);
        this.newUserDialog = true;
      },
      // @vuese
      // Saves the changes user made on a specific user and POST those changes to the API.
      // Handles both cases: editing and creating a new user.
      save() {
        if (this.editedIndex > -1) {
          if (this.$refs.formUser.validate()) {
            axios.put(process.env.API_URL + '/users/' + this.editedItem.id, this.editedItem)
              .then((response) => {
                this.$store.commit('displaySnackbar', 'User \"' + response.data.username + '\" modified');

                this.items.splice(this.editedIndex, 1, response.data);
                this.close();
              });
            // console.log(this.items[this.editedIndex]);
          }
        } else {
          if (this.$refs.formUser.validate()) {
            axios.post(process.env.API_URL + '/users', this.editedItem)
              .then((response) => {
                  this.$store.commit('displaySnackbar', 'User \"' + response.data.username + '\" created');

                this.items.unshift(response.data);
                this.close();

              })

          }
        }
      },
      editUserGroup(item){
        this.editUserOnGroup = 0;
        this.selectGroup = item;
        this.selectGroupName = item.name;
        this.addUserInGroupDialog = true;
      },
      addExsitGroup(){
        this.editUserOnGroup = -1;
        this.addUserInGroupDialog=true;
      },
      addUserGroup(item){
        if(this.selectGroup === undefined ){
          this.$store.commit('displaySnackbar', 'Please select group and region');
          return false;
        }
        let body = {};
        body = {
          user_id:this.editedItem.id,

        };

        if(this.selectGroup){
          if(item.in_group){ // Tick
            axios.post(process.env.API_URL + '/permissiongroups/'+ this.selectGroup.id +
              '/users/'+  this.editedItem.id + '/regions/'+ item.id, body)
              .then((response) => {
                this.updateDataTable();
                this.$store.commit('displaySnackbar', 'add successful');
              })
              .catch((error) => {
                this.$store.commit('displaySnackbar', 'Error: ' + error.response ? error.response.data.error : error);
              });
          } else { // Untick
            axios.delete(process.env.API_URL + '/permissiongroups/'+this.selectGroup.id + '/users/'
              + this.editedItem.id + '/regions/' + item.id)
              .then((response) => {
                this.updateDataTable();
                this.$store.commit('displaySnackbar', 'remove successful');
              })
              .catch((error) => {
                this.$store.commit('displaySnackbar', 'ERROR: Delete failed');
              });
          }
        }

      },
      updateDataTable() {
        this.reload = !this.reload;
      },
      refresh() {
        setTimeout(() => this.isVisible = false, 1000);
        this.isVisible = true;
        this.reload = !this.reload;
      },
      showUserAuditLog(){
        this.userAuditLogDialog = true;
        this.fetchUserAuditLog();
      },
      fetchUserAuditLog(){
        this.userAuditLogLoading = true;
        axios.get(process.env.API_URL + '/users/' + this.editedItem.id + '/permissiongroups/auditlog')
          .then((response) => {
            this.userAuditLogLoading = false;
            this.userAuditLogData = response.data;
          })
          .catch((error) => {
            this.userAuditLogLoading = false;
            this.userAuditLogData = [];
            this.$store.commit('displaySnackbar', 'ERROR: Failed to load audit log');
          });
      },
      closeUserAuditLog(){
        this.userAuditLogDialog = false;
        this.userAuditLogData = [];
      },
    },
    computed: {
      userEdit() {
        return this.$store.getters['auth/hasPermission']('user_edit');
      },
      userView() {
        return this.$store.getters['auth/hasPermission']('user_view');
      },
      permissionUserPermissionView() {
        return this.$store.getters['auth/hasPermission']('user_permission_view');
      },
      permissionUserPermissionEdit() {
        return this.$store.getters['auth/hasPermission']('user_permission_edit');
      },
      regions() {
        return this.$store.state.auth.regions;
      },
      isAdmin() {
        return this.$store.getters['auth/hasPermission']('admin');
      },
      rendereUserPermissionsGroup(){
        if (this.permissionGroup === null || this.permissionGroup === undefined) {
          return [];
        } else {
          return this.permissionGroup;
        }
      },
      rendereAllPermissionsGroup(){
        if (this.allpermissionGroup === null || this.allpermissionGroup === undefined) {
          return [];
        } else {
          this.allpermissionGroup.filter((permissionGroup) => {
            permissionGroup.name = permissionGroup.name + ' (' + permissionGroup.type_text + ')';
          });
          return this.allpermissionGroup;
        }
      },
      renderedRegions() {
        if (this.permissionGroupUserRegions === null || this.permissionGroupUserRegions === undefined) {
          return [];
        } else {
          return this.permissionGroupUserRegions;
        }
      },
    },
    asyncComputed: {
      async clients() {
        return await axios.get(process.env.API_URL + '/clients?inactive=true')
          .then((response) => {
            return response.data;
          })
          .catch((reason) => {
            return [];
          });
      },async permissionGroupUserRegions() {
        if(this.selectGroup){
          if (this.reload || !this.reload) {
            this.loading = true;
            return await axios.get(process.env.API_URL + '/permissiongroups/'
              + this.selectGroup.id + '/users/' + this.editedItem.id + '/regions')
              .then((response) => {
                if (response.status === 200) {
                  this.loading = false;
                  return response.data;
                } else {
                  this.loading = false;
                  return [];
                }
              })
              .catch((error) => {
                this.loading = false;
                return [];
              });
          }
        }
      },
      async permissionGroup(){
        if (this.reload || !this.reload) {
          this.loading = true;
          return await axios.get(process.env.API_URL + '/users/' + this.editedItem.id+ '/permissiongroups')
            .then((response) => {
              if (response.status === 200) {
                this.loading = false;
                return response.data;
              } else {
                this.loading = false;
                return [];
              }
            })
            .catch((error) => {
              this.loading = false;
              return [];
            });
        }
      },
      async allpermissionGroup() {
        if (this.reload || !this.reload) {
          this.loading = true;
          return await axios.get(process.env.API_URL + '/permissiongroups')
            .then((response) => {
              if (response.status === 200) {
                this.loading = false;
                return response.data;
              } else {
                this.loading = false;
                return [];
              }
            })
            .catch((error) => {
              this.loading = false;
              return [];
            });
        }
      },
    }
  }
</script>

<style scoped>

>>>.v-tabs-bar.v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows):not(.v-slide-group--has-affixes) .v-slide-group__prev {
  display: none!important;
}

.line {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 15px;
  background-color: #6754a8;
}

@keyframes loadingC {
0 {transform: translate(0,0);}
50% {transform: translate(0,15px);}
100% {transform: translate(0,0);}
}

.load-3 .line:nth-last-child(1) {animation: loadingC .6s .1s linear infinite;}
.load-3 .line:nth-last-child(2) {animation: loadingC .6s .2s linear infinite;}
.load-3 .line:nth-last-child(3) {animation: loadingC .6s .3s linear infinite;}


</style>




// WEBPACK FOOTER //
// src/components/util/ManageUsers/ManageUsersTable.vue